
var emojiPaletteChars = [
{unicode:"1f600",shortname:":grinning:"},
{unicode:"1f62c",shortname:":grimacing:"},
{unicode:"1f601",shortname:":grin:"},
{unicode:"1f602",shortname:":joy:"},
{unicode:"1f603",shortname:":smiley:"},
{unicode:"1f604",shortname:":smile:"},
{unicode:"1f605",shortname:":sweat_smile:"},
{unicode:"1f606",shortname:":laughing:"},
{unicode:"1f607",shortname:":innocent:"},
{unicode:"1f609",shortname:":wink:"},
{unicode:"1f60a",shortname:":blush:"},
{unicode:"1f642",shortname:":slight_smile:"},
{unicode:"1f643",shortname:":upside_down:"},
{unicode:"263a",shortname:":relaxed:"},
{unicode:"1f60b",shortname:":yum:"},
{unicode:"1f60c",shortname:":relieved:"},
{unicode:"1f60d",shortname:":heart_eyes:"},
{unicode:"1f618",shortname:":kissing_heart:"},
{unicode:"1f617",shortname:":kissing:"},
{unicode:"1f619",shortname:":kissing_smiling_eyes:"},
{unicode:"1f61a",shortname:":kissing_closed_eyes:"},
{unicode:"1f61c",shortname:":stuck_out_tongue_winking_eye:"},
{unicode:"1f61d",shortname:":stuck_out_tongue_closed_eyes:"},
{unicode:"1f61b",shortname:":stuck_out_tongue:"},
{unicode:"1f911",shortname:":money_mouth:"},
{unicode:"1f913",shortname:":nerd:"},
{unicode:"1f60e",shortname:":sunglasses:"},
{unicode:"1f917",shortname:":hugging:"},
{unicode:"1f60f",shortname:":smirk:"},
{unicode:"1f636",shortname:":no_mouth:"},
{unicode:"1f610",shortname:":neutral_face:"},
{unicode:"1f611",shortname:":expressionless:"},
{unicode:"1f612",shortname:":unamused:"},
{unicode:"1f644",shortname:":rolling_eyes:"},
{unicode:"1f914",shortname:":thinking:"},
{unicode:"1f633",shortname:":flushed:"},
{unicode:"1f61e",shortname:":disappointed:"},
{unicode:"1f61f",shortname:":worried:"},
{unicode:"1f620",shortname:":angry:"},
{unicode:"1f621",shortname:":rage:"},
{unicode:"1f614",shortname:":pensive:"},
{unicode:"1f615",shortname:":confused:"},
{unicode:"1f641",shortname:":slight_frown:"},
{unicode:"2639",shortname:":frowning2:"},
{unicode:"1f623",shortname:":persevere:"},
{unicode:"1f616",shortname:":confounded:"},
{unicode:"1f62b",shortname:":tired_face:"},
{unicode:"1f629",shortname:":weary:"},
{unicode:"1f624",shortname:":triumph:"},
{unicode:"1f62e",shortname:":open_mouth:"},
{unicode:"1f631",shortname:":scream:"},
{unicode:"1f628",shortname:":fearful:"},
{unicode:"1f630",shortname:":cold_sweat:"},
{unicode:"1f62f",shortname:":hushed:"},
{unicode:"1f626",shortname:":frowning:"},
{unicode:"1f627",shortname:":anguished:"},
{unicode:"1f622",shortname:":cry:"},
{unicode:"1f625",shortname:":disappointed_relieved:"},
{unicode:"1f62a",shortname:":sleepy:"},
{unicode:"1f613",shortname:":sweat:"},
{unicode:"1f62d",shortname:":sob:"},
{unicode:"1f635",shortname:":dizzy_face:"},
{unicode:"1f632",shortname:":astonished:"},
{unicode:"1f910",shortname:":zipper_mouth:"},
{unicode:"1f637",shortname:":mask:"},
{unicode:"1f912",shortname:":thermometer_face:"},
{unicode:"1f915",shortname:":head_bandage:"},
{unicode:"1f634",shortname:":sleeping:"},
{unicode:"1f4a4",shortname:":zzz:"},
{unicode:"1f480",shortname:":skull:"},
{unicode:"1f47b",shortname:":ghost:"},
{unicode:"1f47d",shortname:":alien:"},
{unicode:"1f916",shortname:":robot:"},
{unicode:"1f63a",shortname:":smiley_cat:"},
{unicode:"1f638",shortname:":smile_cat:"},
{unicode:"1f639",shortname:":joy_cat:"},
{unicode:"1f63b",shortname:":heart_eyes_cat:"},
{unicode:"1f63c",shortname:":smirk_cat:"},
{unicode:"1f63d",shortname:":kissing_cat:"},
{unicode:"1f640",shortname:":scream_cat:"},
{unicode:"1f63f",shortname:":crying_cat_face:"},
{unicode:"1f63e",shortname:":pouting_cat:"},
{unicode:"1f64c",shortname:":raised_hands:"},
{unicode:"1f44f",shortname:":clap:"},
{unicode:"1f44b",shortname:":wave:"},
{unicode:"1f44d",shortname:":thumbsup:"},
{unicode:"1f44e",shortname:":thumbsdown:"},
{unicode:"1f44a",shortname:":punch:"},
{unicode:"270a",shortname:":fist:"},
{unicode:"270c",shortname:":v:"},
{unicode:"1f44c",shortname:":ok_hand:"},
{unicode:"270b",shortname:":raised_hand:"},
{unicode:"1f450",shortname:":open_hands:"},
{unicode:"1f4aa",shortname:":muscle:"},
{unicode:"1f64f",shortname:":pray:"},
{unicode:"261d",shortname:":point_up:"},
{unicode:"1f446",shortname:":point_up_2:"},
{unicode:"1f447",shortname:":point_down:"},
{unicode:"1f448",shortname:":point_left:"},
{unicode:"1f449",shortname:":point_right:"},
{unicode:"1f45a",shortname:":womans_clothes:"},
{unicode:"1f455",shortname:":shirt:"},
{unicode:"1f456",shortname:":jeans:"},
{unicode:"1f454",shortname:":necktie:"},
{unicode:"1f457",shortname:":dress:"},
{unicode:"1f436",shortname:":dog:"},
{unicode:"1f431",shortname:":cat:"},
{unicode:"1f42d",shortname:":mouse:"},
{unicode:"1f439",shortname:":hamster:"},
{unicode:"1f430",shortname:":rabbit:"},
{unicode:"1f43b",shortname:":bear:"},
{unicode:"1f43c",shortname:":panda_face:"},
{unicode:"1f428",shortname:":koala:"},
{unicode:"1f42f",shortname:":tiger:"},
{unicode:"1f981",shortname:":lion_face:"},
{unicode:"1f42e",shortname:":cow:"},
{unicode:"1f437",shortname:":pig:"},
{unicode:"1f43d",shortname:":pig_nose:"},
{unicode:"1f438",shortname:":frog:"},
{unicode:"1f419",shortname:":octopus:"},
{unicode:"1f435",shortname:":monkey_face:"},
{unicode:"1f648",shortname:":see_no_evil:"},
{unicode:"1f649",shortname:":hear_no_evil:"},
{unicode:"1f64a",shortname:":speak_no_evil:"},
{unicode:"1f412",shortname:":monkey:"},
{unicode:"1f414",shortname:":chicken:"},
{unicode:"1f427",shortname:":penguin:"},
{unicode:"1f426",shortname:":bird:"},
{unicode:"1f424",shortname:":baby_chick:"},
{unicode:"1f423",shortname:":hatching_chick:"},
{unicode:"1f425",shortname:":hatched_chick:"},
{unicode:"1f43a",shortname:":wolf:"},
{unicode:"1f417",shortname:":boar:"},
{unicode:"1f434",shortname:":horse:"},
{unicode:"1f984",shortname:":unicorn:"},
{unicode:"1f41d",shortname:":bee:"},
{unicode:"1f41b",shortname:":bug:"},
{unicode:"1f40c",shortname:":snail:"},
{unicode:"1f41e",shortname:":beetle:"},
{unicode:"1f41c",shortname:":ant:"},
{unicode:"1f577",shortname:":spider:"},
{unicode:"1f982",shortname:":scorpion:"},
{unicode:"1f980",shortname:":crab:"},
{unicode:"1f40d",shortname:":snake:"},
{unicode:"1f422",shortname:":turtle:"},
{unicode:"1f420",shortname:":tropical_fish:"},
{unicode:"1f41f",shortname:":fish:"},
{unicode:"1f421",shortname:":blowfish:"},
{unicode:"1f42c",shortname:":dolphin:"},
{unicode:"1f433",shortname:":whale:"},
{unicode:"1f40b",shortname:":whale2:"},
{unicode:"1f40a",shortname:":crocodile:"},
{unicode:"1f406",shortname:":leopard:"},
{unicode:"1f405",shortname:":tiger2:"},
{unicode:"1f403",shortname:":water_buffalo:"},
{unicode:"1f402",shortname:":ox:"},
{unicode:"1f404",shortname:":cow2:"},
{unicode:"1f42a",shortname:":dromedary_camel:"},
{unicode:"1f42b",shortname:":camel:"},
{unicode:"1f418",shortname:":elephant:"},
{unicode:"1f410",shortname:":goat:"},
{unicode:"1f40f",shortname:":ram:"},
{unicode:"1f411",shortname:":sheep:"},
{unicode:"1f40e",shortname:":racehorse:"},
{unicode:"1f416",shortname:":pig2:"},
{unicode:"1f400",shortname:":rat:"},
{unicode:"1f401",shortname:":mouse2:"},
{unicode:"1f413",shortname:":rooster:"},
{unicode:"1f983",shortname:":turkey:"},
{unicode:"1f54a",shortname:":dove:"},
{unicode:"1f415",shortname:":dog2:"},
{unicode:"1f429",shortname:":poodle:"},
{unicode:"1f408",shortname:":cat2:"},
{unicode:"1f407",shortname:":rabbit2:"},
{unicode:"1f43f",shortname:":chipmunk:"},
{unicode:"1f43e",shortname:":feet:"},
{unicode:"1f31e",shortname:":sun_with_face:"},
{unicode:"1f319",shortname:":crescent_moon:"},
{unicode:"2b50",shortname:":star:"},
{unicode:"1f31f",shortname:":star2:"},
{unicode:"1f4ab",shortname:":dizzy:"},
{unicode:"2728",shortname:":sparkles:"},
{unicode:"2604",shortname:":comet:"},
{unicode:"2600",shortname:":sunny:"},
{unicode:"1f324",shortname:":white_sun_small_cloud:"},
{unicode:"26c5",shortname:":partly_sunny:"},
{unicode:"1f325",shortname:":white_sun_cloud:"},
{unicode:"1f326",shortname:":white_sun_rain_cloud:"},
{unicode:"2601",shortname:":cloud:"},
{unicode:"1f327",shortname:":cloud_rain:"},
{unicode:"26c8",shortname:":thunder_cloud_rain:"},
{unicode:"1f329",shortname:":cloud_lightning:"},
{unicode:"26a1",shortname:":zap:"},
{unicode:"1f525",shortname:":fire:"},
{unicode:"1f4a5",shortname:":boom:"},
{unicode:"2744",shortname:":snowflake:"},
{unicode:"1f328",shortname:":cloud_snow:"},
{unicode:"2603",shortname:":snowman2:"},
{unicode:"26c4",shortname:":snowman:"},
{unicode:"1f32c",shortname:":wind_blowing_face:"},
{unicode:"1f4a8",shortname:":dash:"},
{unicode:"1f32a",shortname:":cloud_tornado:"},
{unicode:"1f32b",shortname:":fog:"},
{unicode:"2602",shortname:":umbrella2:"},
{unicode:"2614",shortname:":umbrella:"},
{unicode:"1f4a7",shortname:":droplet:"},
{unicode:"1f4a6",shortname:":sweat_drops:"},
{unicode:"1f30a",shortname:":ocean:"},
{unicode:"1f34f",shortname:":green_apple:"},
{unicode:"1f34e",shortname:":apple:"},
{unicode:"1f350",shortname:":pear:"},
{unicode:"1f34a",shortname:":tangerine:"},
{unicode:"1f34b",shortname:":lemon:"},
{unicode:"1f34c",shortname:":banana:"},
{unicode:"1f349",shortname:":watermelon:"},
{unicode:"1f347",shortname:":grapes:"},
{unicode:"1f353",shortname:":strawberry:"},
{unicode:"1f348",shortname:":melon:"},
{unicode:"1f352",shortname:":cherries:"},
{unicode:"1f351",shortname:":peach:"},
{unicode:"1f34d",shortname:":pineapple:"},
{unicode:"1f345",shortname:":tomato:"},
{unicode:"1f346",shortname:":eggplant:"},
{unicode:"1f336",shortname:":hot_pepper:"},
{unicode:"1f33d",shortname:":corn:"},
{unicode:"1f360",shortname:":sweet_potato:"},
{unicode:"1f36f",shortname:":honey_pot:"},
{unicode:"1f35e",shortname:":bread:"},
{unicode:"1f9c0",shortname:":cheese:"},
{unicode:"1f357",shortname:":poultry_leg:"},
{unicode:"1f356",shortname:":meat_on_bone:"},
{unicode:"1f364",shortname:":fried_shrimp:"},
{unicode:"1f354",shortname:":hamburger:"},
{unicode:"1f35f",shortname:":fries:"},
{unicode:"1f32d",shortname:":hotdog:"},
{unicode:"1f355",shortname:":pizza:"},
{unicode:"1f35d",shortname:":spaghetti:"},
{unicode:"1f32e",shortname:":taco:"},
{unicode:"1f32f",shortname:":burrito:"},
{unicode:"1f35c",shortname:":ramen:"},
{unicode:"1f372",shortname:":stew:"},
{unicode:"1f365",shortname:":fish_cake:"},
{unicode:"1f363",shortname:":sushi:"},
{unicode:"1f371",shortname:":bento:"},
{unicode:"1f35b",shortname:":curry:"},
{unicode:"1f359",shortname:":rice_ball:"},
{unicode:"1f35a",shortname:":rice:"},
{unicode:"1f358",shortname:":rice_cracker:"},
{unicode:"1f362",shortname:":oden:"},
{unicode:"1f361",shortname:":dango:"},
{unicode:"1f367",shortname:":shaved_ice:"},
{unicode:"1f368",shortname:":ice_cream:"},
{unicode:"1f366",shortname:":icecream:"},
{unicode:"1f370",shortname:":cake:"},
{unicode:"1f382",shortname:":birthday:"},
{unicode:"1f36e",shortname:":custard:"},
{unicode:"1f36c",shortname:":candy:"},
{unicode:"1f36d",shortname:":lollipop:"},
{unicode:"1f36b",shortname:":chocolate_bar:"},
{unicode:"1f37f",shortname:":popcorn:"},
{unicode:"1f369",shortname:":doughnut:"},
{unicode:"1f36a",shortname:":cookie:"},
{unicode:"1f37a",shortname:":beer:"},
{unicode:"1f37b",shortname:":beers:"},
{unicode:"1f377",shortname:":wine_glass:"},
{unicode:"1f378",shortname:":cocktail:"},
{unicode:"1f379",shortname:":tropical_drink:"},
{unicode:"1f37e",shortname:":champagne:"},
{unicode:"1f376",shortname:":sake:"},
{unicode:"1f375",shortname:":tea:"},
{unicode:"2615",shortname:":coffee:"},
{unicode:"1f37c",shortname:":baby_bottle:"},
{unicode:"1f374",shortname:":fork_and_knife:"},
{unicode:"1f37d",shortname:":fork_knife_plate:"},
{unicode:"1f697",shortname:":red_car:"},
{unicode:"1f695",shortname:":taxi:"},
{unicode:"1f699",shortname:":blue_car:"},
{unicode:"1f68c",shortname:":bus:"},
{unicode:"1f68e",shortname:":trolleybus:"},
{unicode:"1f3ce",shortname:":race_car:"},
{unicode:"1f693",shortname:":police_car:"},
{unicode:"1f691",shortname:":ambulance:"},
{unicode:"1f692",shortname:":fire_engine:"},
{unicode:"1f690",shortname:":minibus:"},
{unicode:"1f69a",shortname:":truck:"},
{unicode:"1f69b",shortname:":articulated_lorry:"},
{unicode:"1f69c",shortname:":tractor:"},
{unicode:"1f3cd",shortname:":motorcycle:"},
{unicode:"1f6b2",shortname:":bike:"},
{unicode:"1f6a8",shortname:":rotating_light:"},
{unicode:"1f694",shortname:":oncoming_police_car:"},
{unicode:"1f68d",shortname:":oncoming_bus:"},
{unicode:"1f698",shortname:":oncoming_automobile:"},
{unicode:"1f696",shortname:":oncoming_taxi:"},
{unicode:"1f6a1",shortname:":aerial_tramway:"},
{unicode:"1f6a0",shortname:":mountain_cableway:"},
{unicode:"1f69f",shortname:":suspension_railway:"},
{unicode:"1f683",shortname:":railway_car:"},
{unicode:"1f68b",shortname:":train:"},
{unicode:"1f69d",shortname:":monorail:"},
{unicode:"1f684",shortname:":bullettrain_side:"},
{unicode:"1f685",shortname:":bullettrain_front:"},
{unicode:"1f688",shortname:":light_rail:"},
{unicode:"1f69e",shortname:":mountain_railway:"},
{unicode:"1f682",shortname:":steam_locomotive:"},
{unicode:"1f686",shortname:":train2:"},
{unicode:"1f687",shortname:":metro:"},
{unicode:"1f68a",shortname:":tram:"},
{unicode:"1f689",shortname:":station:"},
{unicode:"1f681",shortname:":helicopter:"},
{unicode:"1f6e9",shortname:":airplane_small:"},
{unicode:"2708",shortname:":airplane:"},
{unicode:"1f6eb",shortname:":airplane_departure:"},
{unicode:"1f6ec",shortname:":airplane_arriving:"},
{unicode:"26f5",shortname:":sailboat:"},
{unicode:"1f6e5",shortname:":motorboat:"},
{unicode:"1f6a4",shortname:":speedboat:"},
{unicode:"26f4",shortname:":ferry:"},
{unicode:"1f6f3",shortname:":cruise_ship:"},
]

export default emojiPaletteChars;



// WEBPACK FOOTER //
// ./src/helpers/emoji-palette-chars.js